import NotesManager from './manage'
import NotesRecord from './record'

export {
  NotesManager,
  NotesRecord,
}
